import { useLocation, useNavigate } from 'react-router-dom';
import { IconNavBack } from './svgs';

interface NavbarProps {
  title: string;
  onBack?: () => void;
}

function Navbar({ title, onBack }: NavbarProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }

    if (location.pathname === '/home' || location.pathname === '/joinservice') {
      //if (window.history.length <= 1) {
        window.location.assign('http://command/close');
        return;
      //}

      //navigate(-1);
      //return;
    }

    navigate(-1);
  };

  return (
    <div className="flex h-[48px] items-center justify-between px-4 py-3">
      <button
        onClick={handleBack}
        className="flex cursor-pointer items-center justify-center border-none bg-transparent"
      >
        <IconNavBack />
      </button>

      <span className="items-center text-lg font-medium leading-5 text-white">{title}</span>

      <div className="w-6"></div>
    </div>
  );
}

export default Navbar;